import React from "react";
import {Avatar, IconButton, Typography, Box} from "@mui/material";
import {grey} from "@mui/material/colors";
import {Close} from "@mui/icons-material";
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import moment from "moment";

import {SESSION_LABEL} from "../../availability/TimeslotContextMenu";
import {SESSION_TYPE} from "../../../domain/SessionType";
import {retrieveServiceTypeIcon} from "../../../helpers/ServiceTypeUtils";
import {SLIDING_SESSION_TIME_FORMAT} from "../../../config/DateTimeConstants";

const styles = {
    sessionIcon: {
        color: '#000000'
    },
    header: {
        serviceTypeIndicator: (color) => ({
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            backgroundColor: color,
            width: "100%",
            height: "2.5rem",
            justifyContent: "space-between",
        }),
        leftContentBox: {
            display: "flex",
            alignItems: "center",
            gap: "0.5rem"
        }
    },
    avatar: {
        serviceType: {
            marginLeft: "0.5rem",
            width: 26,
            height: 26,
            backgroundColor: "white"
        }
    },
    typography: {
        timeText: {
            margin: "0.3rem 0 0.25rem 0.5rem",
            fontSize: "1rem",
            fontWeight: 500,
        },
        serviceTypeName: {
            color: "white",
            fontWeight: "600"
        }
    },
    button: {
        close: {
            padding: "0.25rem",
            marginRight: "0.5rem",
            color: "white"
        }
    },
    icon: {
        image: {
            width: 22,
            height: 22
        }
    }
};

export default function SlidingSessionHeader({selectedEvent, serviceTypeDetails, handleHeaderClose, hasNoSession}) {

    const headerColor = hasNoSession ? grey[500] : serviceTypeDetails?.color;
    const showHeader = hasNoSession || serviceTypeDetails?.type;
    const isTrainingSession = selectedEvent.sessionType === SESSION_TYPE.TRAINING;
    const NonTeachingSessionIcon = isTrainingSession ? LocalLibraryIcon : FreeBreakfastIcon;

    return (
        <Box>
            {
              showHeader
              &&
              (
                <Box sx={styles.header.serviceTypeIndicator(headerColor)}>
                    <Box sx={styles.header.leftContentBox}>
                        <Avatar sx={styles.avatar.serviceType}>
                            {
                              hasNoSession
                              ? <NonTeachingSessionIcon sx={styles.sessionIcon} fontSize="small"/>
                              : <Box
                                  component="img"
                                  src={retrieveServiceTypeIcon([serviceTypeDetails.type])}
                                  sx={styles.icon.image}/>
                            }
                        </Avatar>
                        <Typography sx={styles.typography.serviceTypeName}>
                            {
                                hasNoSession
                                ? SESSION_LABEL[selectedEvent.sessionType]
                                : serviceTypeDetails.type
                            }
                        </Typography>
                    </Box>
                    {
                      handleHeaderClose
                      &&
                      (
                        <IconButton
                          size="small"
                          onClick={handleHeaderClose}
                          sx={styles.button.close}>
                            <Close fontSize="small"/>
                        </IconButton>
                      )
                    }
                </Box>
              )
            }
            <Typography sx={styles.typography.timeText}>
                {moment(selectedEvent.from).format(SLIDING_SESSION_TIME_FORMAT)}
            </Typography>
        </Box>
    );
}
